import cookie from '@s-ui/js/lib/cookie'

import factoryLogger from '../../logger/index.js'
import FetcherErrorsFactory from '../Errors/factory.js'
import FetcherFactory from '../Fetchers/factory.js'
import ConfigFetcherRepository from './ConfigFetcherRepository.js'
import CookieFetcherRepository from './CookieFetcherRepository.js'
import HTTPFetcherRepository from './HTTPFetcherRepository.js'

export default class FetcherRepositoriesFactory {
  static cookieFetcherRepository = ({config}) =>
    new CookieFetcherRepository({
      cookie,
      config
    })

  static configFetcherRepository = ({config}) =>
    new ConfigFetcherRepository({
      config,
      errorFactory: FetcherErrorsFactory.fetcherError
    })

  static httpFetcherRepository = ({config}) =>
    new HTTPFetcherRepository({
      log: factoryLogger({prefix: 'HTTPFetcherRepository'}),
      fetcher: FetcherFactory.httpFetcher({config}),
      localRepository: FetcherRepositoriesFactory.cookieFetcherRepository({
        config
      }),
      apiWebUrl: config.get('API_URL')
    })
}
